import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, iif, Observable, of } from 'rxjs';
import { filter, shareReplay, switchMap, take, tap } from 'rxjs/operators';
import { BildungszielClient, BildungszielServiceParams } from '../integration/bildungsziel.client';
import { UrlService } from '../state/url.service';

@Injectable({
  providedIn: 'root'
})
export class BildungszielService {
  private readonly bildungszielClient = inject(BildungszielClient);

  private readonly _oberknoten$ = new BehaviorSubject<number[]>([]);

  public dkzIds$ = this._oberknoten$.pipe(
    switchMap((dkzIds) => iif(() => dkzIds.length > 0, this.loeseOberknotenAuf(dkzIds), of([]))),
    shareReplay()
  );

  public setzeOberknoten(dkzIds: number[]): void {
    this._oberknoten$.next(dkzIds);
  }

  private loeseOberknotenAuf(dkzIds: number[]): Observable<number[]> {
    return this.bildungszielClient
      .getBildungszielForSeteId(
        new HttpParams().set(
          BildungszielServiceParams.OBERKNOTEN_DKZ_IDS,
          dkzIds?.join(UrlService.VALUE_SEPARATOR)
        )
      )
      .pipe(
        take(1),
        filter((id) => id !== null)
      );
  }
}
